import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import MenuProduct, { MenuProductModelPropTypes } from '../common/menu-product';

const { Order, UI, Locations, Menu } = Mobi2Go;

class Products extends React.Component {
    static propTypes = {
        data: PropTypes.arrayOf(PropTypes.shape(MenuProductModelPropTypes))
            .isRequired,
        min_height: PropTypes.number,
    };

    static defaultProps = {
        min_height: null,
    };

    constructor(...args) {
        super(...args);

        this.product_nodes = {};
    }

    getProductNodes = () => this.product_nodes;

    onProductCustomiseClick = ({ menu_product, selected_size }) => {
        this.addProductToOrder(menu_product, selected_size, true);
    };

    onProductClick = ({ menu_product, selected_size }) => {
        this.addProductToOrder(menu_product, selected_size, false);
    };

    addProductToOrder = (menu_product, selected_size, do_not_quick_add) => {
        const { id } = menu_product;
        const product = Menu.getProducts().find({ id });
        if (!product) {
            throw new Error('Product not found');
        }

        const order_product = product.createOrderProductInstance();
        const has_sizes =
            menu_product.hasTag('display-size-options') &&
            menu_product.getSizeOptions().length > 1;

        if (has_sizes && selected_size) {
            order_product.setSizeByName(selected_size);
        }

        const should_prompt_for_location_choice =
            !Order.getLocation() && Locations.hasLocationFirstOrderFlow();

        // Quick add
        if (
            !do_not_quick_add &&
            (order_product.shouldQuickAddToOrder() ||
                (has_sizes &&
                    !order_product.getUnmetSelectionRequirementModifierGroup()))
        ) {
            if (should_prompt_for_location_choice) {
                UI.trigger('showLocationsFinder');
                _.defer(() => {
                    Order.addProduct(order_product);
                });
            } else {
                Order.addProduct(order_product);
            }

            return;
        }

        // Product editor modal
        if (should_prompt_for_location_choice) {
            UI.trigger('showLocationsFinder');
            _.defer(() => {
                Order.addProduct(order_product);
                UI.once('modalClose', () => {
                    // We must defer to allow unavailable/oss products to be removed
                    // from order if necessary.
                    _.defer(() => {
                        if (Order.containsProduct(order_product)) {
                            UI.trigger('editProduct', order_product);
                        }
                    });
                });
            });
        } else {
            UI.trigger('editProduct', order_product);
        }
    };

    render = () => {
        const { data, min_height } = this.props;
        return (
            <div className="m2g-menu-products-list">
                {data.map(menu_product => (
                    <MenuProduct
                        key={menu_product.id}
                        menu_product={menu_product}
                        min_height={min_height}
                        onClick={this.onProductClick}
                        onCustomiseClick={this.onProductCustomiseClick}
                        ref={e => {
                            this.product_nodes[menu_product.id] = e;
                        }}
                    />
                ))}
            </div>
        );
    };
}

export default Products;
